<template lang="pug">
v-card(outlined).mb-4
  v-card-title Информация о профиле
  v-card-text
    p.subtitle-1(v-if="user.region_id") Регион: {{ cachedRegion(user.region_id).name }}
    div.d-flex.align-center
      span.subtitle-1.mr-2 Роль:
      v-chip(label color="primary" user.roles v-for="role in user.roles" :key="role")
        | {{ ROLES_NAMES[role] }}
</template>

<script>
import { ROLES_NAMES } from '@/constants';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      ROLES_NAMES,
    };
  },
  computed: {
    ...mapGetters({
      'userRole': 'auth/userRole',
      'user':'auth/getUser',
      'cachedRegion': 'cache/cachedRegion',
    }),
  },

  methods: {

  },
};
</script>

<style></style>
